import { Entry, EntryType, ModalSize } from "./types";

// ENG-20770 FE-side fallback for entry types whose target modal is known
// to require a non-default frame size. Backend values still take precedence.
const ENTRY_TYPE_MODAL_SIZE: Partial<Record<string, ModalSize>> = {
  [EntryType.DOCUMENT]: "fullscreen", // /clinical/document/modals/preview type="full"
  [EntryType.TASK]: "fullscreen", // only when taskType === "file_inbound_document_task" — see resolveEntryModalSize
};

export function resolveEntryModalSize(entry: Entry): ModalSize | undefined {
  if (entry.type === EntryType.TASK) {
    return (
      entry.modalSize ??
      (entry.taskType === "file_inbound_document_task" ? "fullscreen" : undefined)
    );
  }
  return entry.modalSize ?? ENTRY_TYPE_MODAL_SIZE[entry.type];
}

export const conceptsToOpenModal = [
  {
    conceptId: "163020007",
    type: EntryType.OBSERVATION,
  },
  {
    conceptId: "162913005",
    type: EntryType.OBSERVATION,
  },
  {
    conceptId: "309646008",
    type: EntryType.OBSERVATION,
  },
  {
    conceptId: "162986007",
    type: EntryType.OBSERVATION,
  },
  {
    conceptId: "33747003",
    type: EntryType.OBSERVATION,
  },
  {
    conceptId: "302789003",
    type: EntryType.OBSERVATION,
  },
  {
    conceptId: "162763007",
    type: EntryType.OBSERVATION,
  },
  {
    conceptId: "162755006",
    type: EntryType.OBSERVATION,
  },
  {
    conceptId: "363787002",
    type: EntryType.OBSERVATION,
  },
  {
    conceptId: "420134006",
    type: EntryType.ALLERGY,
  },
  {
    conceptId: "281647001",
    type: EntryType.ALLERGY,
  },
];

export const conceptsToPromptProblemCreation = [
  {
    conceptId: "64572001",
  },
  {
    conceptId: "48694002",
  },
  {
    conceptId: "773760007",
  },
];
